import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation, OnDestroy } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessDialogServiceSub } from './../../../commons/kymw00/pless-dialog-service-sub';
import { PlessHttp } from '../../../shared/http/pless-http.service';
import { GetDashboardMessageService } from './api-services/get-dashboard-message.service';
import { GetDashboardLockInfoService } from './api-services/get-dashboard-lock-info.service';
import { PageLockService } from '../../../commons/kymw00/api-services/page-lock.service';
import { CatalogLockService } from '../../../commons/kymw00/api-services/catalog-lock.service';
import { GoodsLockService } from '../../../commons/kymw00/api-services/goods-lock.service';
import { PlanGoodsLockService } from '../../../commons/kymw00/api-services/plan-goods-lock.service';
import { ReleaseImageLockService } from './api-services/release-image-lock.service';
import { GetInfomationService } from './api-services/get-infomation.service';
import { KYMW1002Model } from './kymw1002.model';
import { DashboardMessageInfo } from './vo/dashboard-message-info.model';
import { ReleaseImageLock } from './vo/release-image-lock.model';
import { Router } from '@angular/router';
import { CellType, GridPanel, FlexGrid } from '@grapecity/wijmo.grid';
import { FlexGridFilter, FilterType } from '@grapecity/wijmo.grid.filter';
import { DataGridUtil } from './../../../commons/kymw00/data-grid-util';
import { Menu } from '@grapecity/wijmo.input';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { LoginUserInfoService } from '../kymw1001/login-services/loginUserInfo.service';
import { Subscription } from 'rxjs';
import { DownloadResultLogService } from './api-services/download-resultlog.service';
import { GetResultLogPathService } from './api-services/get-result-log-path.service';
import { GetUserSupplierCodeListService } from './api-services/get-user-supplier-code-list.service';
import { UpdateAssociatedCompanyIdService } from './api-services/update-associated-company-id.service';
import * as wijmo from '@grapecity/wijmo';

/**
 * ダッシュボード画面
 *
 * @export KYMW1002Component
 * @class KYMW1002Component
 * @implements {OnInit}
 */
@Component({
  selector: 'app-kymw1002',
  templateUrl: './kymw1002.component.html',
  styleUrls: ['./kymw1002.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: PageLockService,
      useFactory: (plessHttp: PlessHttp, dialogService: PlessDialogServiceSub) => new PageLockService(plessHttp, dialogService),
      deps: [PlessHttp, PlessDialogServiceSub]
    },
    {
      provide: CatalogLockService,
      useFactory: (plessHttp: PlessHttp, dialogService: PlessDialogServiceSub) => new CatalogLockService(plessHttp, dialogService),
      deps: [PlessHttp, PlessDialogServiceSub]
    },
    {
      provide: GoodsLockService,
      useFactory: (plessHttp: PlessHttp, dialogService: PlessDialogServiceSub) => new GoodsLockService(plessHttp, dialogService),
      deps: [PlessHttp, PlessDialogServiceSub]
    },
    {
      provide: PlanGoodsLockService,
      useFactory: (plessHttp: PlessHttp, dialogService: PlessDialogServiceSub) => new PlanGoodsLockService(plessHttp, dialogService),
      deps: [PlessHttp, PlessDialogServiceSub]
    },
  ]
})

export class KYMW1002Component extends PlessViewHelperSub implements OnInit, OnDestroy {
  @ViewChild('dtg_DashboardLockInfoList', { static: true }) dtg_DashboardLockInfoList: FlexGrid;
  @ViewChild('btn_DashboardLockUpdate', { static: true }) btn_DashboardLockUpdate: ElementRef;
  @ViewChild('fltr_Main', { static: false }) fltr_Main: FlexGridFilter;

  public kymw1002Model: KYMW1002Model = new KYMW1002Model();

  // メッセージリンクのid名(index除く)
  private mssageLinkIdName: string = 'dashboardMessageLink';

  // ロック情報のコンテキストメニュー(右クリック)
  public cmDtgDashboardLockInfoList: Menu;
  // ロック情報で選択した行インデックス
  private lockRowIndex: any = null;
  // ロック情報取得時に渡す種別リスト
  public lockInfoType: Object = {
    init: 'init',
    release: 'release',
    update: 'update'
  };
  private subScription: Subscription | null = null;
  private static readonly BETWEEN_MEDIUM_ADMIN_RESULT_LOG_CODE_VALUE = '2799';
  public isAdmin = false;

  public saveFilterDef = '';
  public saveSortDef: any;


  // フィルター対象カラム
  private static readonly FILTER_TARGET_COLUMS = [
    'lockFunc',
    'lockTarget',
    'lockDate',
    'lockName',
  ];

  /**
   *Creates an instance of KYMW1000Component.
   * @param {GetDashboardMessageService} getDashboardMessageService
   * @param {GetDashboardLockInfoService} getDashboardLockInfoService
   * @param {PageLockService} pageLockService
   * @param {CatalogLockService} catalogLockService
   * @param {GoodsLockService} goodsLockService
   * @param {PlanGoodsLockService} planGoodsLockService
   * @param {ReleaseImageLockService} releaseImageLockService
   * @param {GetInfomationService} getInfomationService
   * @param {PageLockService} pageLockServiceSub
   * @param {CatalohLockService} catalogLockServiceSub
   * @param {GoodsLockService} goodsLockServiceSub
   * @param {PlanGoodsLockService} planGoodsLockServiceSub
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @param {DownloadResultLogService} downloadResultLogService
   * @param {GetResultLogPathService} getResultLogPathService
   * @memberof KYMW1002Component
   */

  constructor(
    public getDashboardMessageService: GetDashboardMessageService,
    public getDashboardLockInfoService: GetDashboardLockInfoService,
    public releaseImageLockService: ReleaseImageLockService,
    public getInfomationService: GetInfomationService,
    private pageLockServiceSub: PageLockService,
    private catalogLockServiceSub: CatalogLockService,
    private goodsLockServiceSub: GoodsLockService,
    private planGoodsLockServiceSub: PlanGoodsLockService,
    public dialogService: PlessDialogServiceSub,
    public kymw00Model: KYMW00Model,
    public downloadResultLogService: DownloadResultLogService,
    public getResultLogPathService: GetResultLogPathService,
    private loginUserInfoService: LoginUserInfoService,
    private getUserSupplierCodeListService: GetUserSupplierCodeListService,
    private updateAssociatedCompanyIdService: UpdateAssociatedCompanyIdService,
    private router: Router) {
    super(kymw00Model);
  }

  public ngOnInit(): void {
    this.componentName = 'KYMW1002';
    this.kymw1002Model.kymw1002Component = this;
    this.pageLockService = this.pageLockServiceSub;
    this.catalogLockService = this.catalogLockServiceSub;
    this.goodsLockService = this.goodsLockServiceSub;
    this.planGoodsLockService = this.planGoodsLockServiceSub;
    this.downloadResultLogService = this.downloadResultLogService;
    this.getResultLogPathService = this.getResultLogPathService;

    // ログインユーザー情報が取得できるまで監視、取得出来たら後続処理を行う
    this.subScription = this.loginUserInfoService.loginUserInfo$.subscribe(info => {
      if (info) {
        if (!PlessViewUtilsSub.isEmpty(info.AdminDiv)){
          // ダッシュボードに必要な情報を取得
          this.getDashBoardInfo(info.AdminDiv);
        }
      }
    });

    // お知らせ
    const vo = {
      // 「INFO2」の固定値
      forWholeInfo_ColumnName: 'INFO2'
    };
    this.getInfomationService.execute(this.kymw1002Model, vo);

    // 取引先情報
    this.getUserSupplierCodeListService.execute((data) => {
      let tempList = <any>[];
      data.SupplierInfoList.map(_ => {
        tempList.push({
          supplierCode: _.SupplierCode,
          supplierCodeName: _.SupplierCodeName,
        })
      });
      this.kymw1002Model.supplierInfoList = tempList;
    });
  }

  ngOnDestroy(): void {
    // 購買解除
    this.subScription.unsubscribe();  
  }

  public initMain(g: FlexGrid) {
    // フィルタ 設定
    if (this.fltr_Main) {
      this.fltr_Main.defaultFilterType = FilterType.Both;
      this.fltr_Main.showSortButtons = false;
      this.fltr_Main.filterColumns = KYMW1002Component.FILTER_TARGET_COLUMS;
    }
  }

s  /**
   * 各種メッセージ・ロック情報取得後の画面描画処理
   *
   * @param adminDiv 管理者権限
   * @memberof KYMW1002Component
   */
  private setViewInit(adminDiv): void {
    // HTML要素ができていないことがあるので遅延評価
    setTimeout(() => {
      // メッセージリンクの設定
      let i: number;
      const info = this.kymw1002Model.dashboardMessageInfoList['MessageInfoList'];
      for (i = 0; i < info.length; i++) {
        if(info[i].MIFormId == KYMW1002Component.BETWEEN_MEDIUM_ADMIN_RESULT_LOG_CODE_VALUE){
          // メッセージリンク押下時の処理ログダウンロード処理
          document.getElementById(this.mssageLinkIdName + i).addEventListener('click', (e: any) => {
            // 文字要素以外を押した場合は何もしない
            if (e.target == e.currentTarget) {
              return;
            }
            this.getResultLogPathService.execute(
              this.kymw1002Model,
              KYMW1002Component.BETWEEN_MEDIUM_ADMIN_RESULT_LOG_CODE_VALUE,
              () => {
                this.downloadResultLogService.execute(this.kymw1002Model);
              }
            );
          });
        } else if (info[i].MIFormId !== '') {
          // メッセージリンク押下時の画面遷移処理
          document.getElementById(this.mssageLinkIdName + i).addEventListener('click', (e: any) => {
            let navigateInfo: any = e.currentTarget.id;
            this.router.navigate(['/kymw/' + info[navigateInfo.slice(this.mssageLinkIdName.length)].MIFormId]);
          });
        }
      }
    }, 500)

    // ロック情報取得後の設定処理
    if (adminDiv === '1') {
      this.setLockInfo();
    }

    // 取引先情報をkymw1001から取得
    this.kymw1002Model.supplierCode = this.kymw00Model.kymw1001Model.loginUserInfo.SupplierCode;
  }

  /**
   * ロック情報取得後の設定処理
   *
   * @memberof KYMW1002Component
   */
  private setLockInfo(): void {
    // ロック情報 表示用データの生成
    this.kymw1002Model.getShowDashboardLockInfoList(this.kymw1002Model.dashboardLockInfoList);
    this.dtg_DashboardLockInfoList.collectionView.refresh();
    // コンテキストメニュー設定処理
    this.setContextMenu();
  }

  /**
   * コンテキストメニュー設定処理
   *
   * @memberof KYMW1002Component
   */
  private setContextMenu(): void {
    this.cmDtgDashboardLockInfoList = new Menu(document.createElement('div'),
      {
        displayMemberPath: 'caption',
        selectedValuePath: 'cmd',
        itemsSource: [
          { header: 'ロック解除', caption: 'ロック解除', cmd: 'updateDashboardLockInfo', enabled: true },
        ],
        command: {
          canExecuteCommand: param => {
            return param.enabled === false ? false : true;
          },
        },
        // イベント設定
        itemClicked: (s, e) => {
          switch (this.cmDtgDashboardLockInfoList.selectedValue) {
            case 'updateDashboardLockInfo':
              this.eventUpdDashboardLockInfo_CLICKHandler(this.lockRowIndex);
              break;
          }
        }
      }
    );

    // 右クリック押下時 コンテキストメニュー表示処理
    this.dtg_DashboardLockInfoList.hostElement.addEventListener('contextmenu', (e: any) => {
      // イベントを停止後、メニュー表示
      e.preventDefault();
      // 右クリックで対象行を選択状態にする
      DataGridUtil.showContextMenu(this.dtg_DashboardLockInfoList, this.cmDtgDashboardLockInfoList, e);
      // 選択行のインデックスを取得し、ロック解除対象データを特定する
      const ht = this.dtg_DashboardLockInfoList.hitTest(e.pageX, e.pageY);
      this.lockRowIndex = ht.row;
    });
  }

  /**
  * ロック解除後の再描画処理
  * 
  * @param index ロック解除対象行のindex
  * @memberof KYMW1002Component
  */
  public afterReleaseView(): void {
    setTimeout(() => {
      this.kymw1002Model.deleteLockInfo(this.lockRowIndex);
      this.getDashboardLockInfoService.execute(this.kymw1002Model, this.lockInfoType['release'], () => {
        // ロック情報を強制リフレッシュ
        this.getDashboardLockInfoService.execute(this.kymw1002Model, this.lockInfoType['update'], () => {
          this.setLockInfo();
          setTimeout(() => {
            this.storeFilterAndSort();
          })
         });
      })
    });
  }

  /**
  * ロック解除ボタン押下時処理
  * 
  * @param index ロック解除対象行のindex
  * @memberof KYMW1002Component
  */
  public eventUpdDashboardLockInfo_CLICKHandler(index: any): void {

    this.saveFilterDef = this.fltr_Main.filterDefinition;
    this.saveSortDef = this.dtg_DashboardLockInfoList.collectionView.sortDescriptions.map(item => {
      return {
        property: item.property,
        ascending: item.ascending             
      };
    });

    const selectedItem = this.dtg_DashboardLockInfoList.selectedItems[0];
    switch (selectedItem.LockType) {
      case 'PAGE':
        // ページロック情報解除APIを呼び出す
        super.LockUtilForPage('RELEASE'
          , selectedItem.OrderCode
          , selectedItem.MediumType
          , selectedItem.PageId
          , null
          , null
          , null
          , null
          , false
          , selectedItem.LockerId
        );
        // 画面を再描画
        this.afterReleaseView();
        break;
      case 'CATALOG':
        // 企画ロック情報解除APIを呼び出す
        this.LockUtilForCatalog('RELEASE'
          , selectedItem.OrderCode
          , selectedItem.MediumType
          , null
          , null
          , null
          , null
          , false
          , false
          , selectedItem.LockerId
        );
        // 画面を再描画
        this.afterReleaseView();
        break;
      case 'GOODS':
        // 商品ロック情報解除APIを呼び出す
        super.LockUtilForGoods('RELEASE'
          , selectedItem.PCode
          , null
          , null
          , null
          , null
          , false
          , selectedItem.LockerId
        );
        // 画面を再描画
        this.afterReleaseView();
        break;
      case 'PLANGOODS':
        // 企画商品ロック情報解除APIを呼び出す
        this.LockUtilForPlanGoods('RELEASE'
          , selectedItem.OrderCode
          , selectedItem.MediumType
          , selectedItem.PCode
          , null
          , null
          , null
          , null
          , false
          , selectedItem.LockerId
        );
        // 画面を再描画
        this.afterReleaseView();
        break;
      case 'IMAGE':
        const vo: ReleaseImageLock = new ReleaseImageLock();
        vo.processName = this.kymw1002Model.dashboardLockInfoList.LockInfoList[index].ProcessName;
        vo.userId = this.kymw1002Model.dashboardLockInfoList.LockInfoList[index].LockerId ?
          this.kymw1002Model.dashboardLockInfoList.LockInfoList[index].LockerId : this.kymw00Model.kymw1001Model.loginUserInfo?.UserID;
        // 画像ロック情報解除APIを呼び出す
        this.releaseImageLockService.execute(this.kymw1002Model, index, vo,
          (data: any) => this.getDashboardLockInfoService.execute(this.kymw1002Model, this.lockInfoType['release'], () => {
            // グリッドの更新
            this.dtg_DashboardLockInfoList.collectionView.refresh();
            setTimeout(() => {
              this.storeFilterAndSort();
            })
          })
        )
        break;
    }
  }

  /**
   * ロック情報更新ボタン押下時処理
   *
   * @param event 選択時イベント
   */
  public eventDashboardLockUpdate_CLICKHandler(): void {
    // ロック情報取得APIを呼び出す
    this.getDashboardLockInfoService.execute(this.kymw1002Model, this.lockInfoType['update'],
      (data: any) => this.setLockInfo());
  }

  /**
   * ダッシュボード画面に表示する情報取得処理
   *
   * @param loginUserInfo ログインユーザー情報
   */
  public getDashBoardInfo(adminDiv): void {
    // メッセージ情報取得VO
    const messageVo: DashboardMessageInfo = new DashboardMessageInfo();
    messageVo.userId = this.kymw00Model.kymw1001Model.loginUserInfo?.UserID;
    messageVo.messageShowDate = PlessViewUtilsSub.formatedNowDate('YYYY/MM/DD');

    // ダッシュボード画面に表示する情報を取得する(API取得)
    // 各種メッセージ情報、管理者の場合のみロック情報も取得
    if (adminDiv === '1'){
      this.isAdmin = true;
      this.getDashboardMessageService.execute(this.kymw1002Model, messageVo,(data: any) => 
        this.getDashboardLockInfoService.execute(this.kymw1002Model, this.lockInfoType['init'], 
          (data: any) => this.setViewInit(adminDiv)));
    } else {
      this.isAdmin = false;
      this.getDashboardMessageService.execute(this.kymw1002Model, messageVo,(data: any) => this.setViewInit(adminDiv));   
    }
  }

  /**
   * 所属情報の変更処理イベント
   */
  public supplierCode_CHANGEHandler(): void {
    // 関連会社ID更新API実行
    this.updateAssociatedCompanyIdService.execute(this.kymw1002Model, () => {
      // 画面リロード
      window.location.reload();
    });
  }

  public storeFilterAndSort(){
    if (this.saveFilterDef != '') {
      this.fltr_Main.filterDefinition = this.saveFilterDef;
      this.fltr_Main.apply();
    }
    if (this.saveSortDef) {
      const cv = this.dtg_DashboardLockInfoList.collectionView;
      if (cv) {

        cv.beginUpdate();
        cv.sortDescriptions.clear();
        this.saveSortDef.forEach(item => {
          const sortDesc = new wijmo.SortDescription(item.property, item.ascending);
          cv.sortDescriptions.push(sortDesc);
        });
        cv.endUpdate();

        if (cv.items.length > 0) {
          this.dtg_DashboardLockInfoList.select(0, 0);
        }

      }
    }

  }
  
}